import Features from "./features";

const HomeHeroSection = () => {
  const handleGetStartedClick = () => {
    // Redirect to the login URL when the button is clicked
    window.location.href = `https://legittmateai.com/legitt-pro/app/login`;
  };

  return (
    <div className="bg-white mt-20">
      <div className="flex justify-center items-center text-gray-700">
        <div
          className="text-center hidden md:inline-flex justify-between items-center py-1 px-1 pr-4 mb-7 text-sm  bg-gray-100 rounded-full hover:bg-gray-200"
          role="alert"
        >
          <span className="text-xs bg-primary-600 rounded-full text-black px-3 py-1.5">
            New
          </span>{" "}
          <h2 className="text-sm font-medium inline-block ">
            AI Chatbot Software: Transform Chats into Sales
          </h2>
          <svg
            className="ml-2 w-5 h-5"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
              clipRule="evenodd"
            ></path>
          </svg>
        </div>
      </div>
      <h1 className="text-2xl px-4 md:text-4xl lg:text-5xl font-bold text-gray-700  max-w-4xl leading-relaxed lg:leading-snug text-center mx-auto ">
        Convert Visitors into Leads Instantly with LegittMate AI
      </h1>
      <p className="mt-[15px] mx-auto max-w-screen-xl  text-center md:text-[16px] font-[600] text-gray-500 lg:text-[18px] px-4 sm:px-16 xl:px-48 ">
        Engage, Convert, and Grow Your Sales with LegittMate AI!
      </p>
      <div className="flex justify-center items-center">
        <button
          className="contained text-white px-4 py-2 rounded-md mt-4"
          onClick={handleGetStartedClick}
        >
          Get Started
        </button>
      </div>
      <Features />
    </div>
  );
};

export default HomeHeroSection;
